<script setup>
import { computed, toRefs } from 'vue';
const hexOpacity = '66'

const props = defineProps({
    shadow: {
        type: String,
        default: '' // default to the initial color
    }
});

const { shadow } = toRefs(props);

const cardStyle = computed(() => ({
    '--shadow-color': shadow.value,
    '--animated-shadow-color': shadow.value + hexOpacity
}));
</script>

<template>
    <div :style="cardStyle" class="redesign-base-card">
        <slot name="content"></slot>
    </div>
</template>

<style scoped lang="scss">
.redesign-base-card {
    border: 1px solid var(--colorWidgetBorder-color);
    border-radius: 8px;
    overflow: hidden;
    animation: blink-shadow 2s infinite;
}

@keyframes blink-shadow {
    0% {
        box-shadow: 0 0 9px 0 var(--shadow-color);
    }
    50% {
        box-shadow: 0 0 11px 0 var(--animated-shadow-color);
    }
    100% {
        box-shadow: 0 0 9px 0 var(--shadow-color);
    }
}
</style>
